import { z } from "zod";

const emailSchema = z
  .string()
  .trim()
  .min(1, { error: "Email address is required." })
  .pipe(z.email({ error: "Please enter a valid email address." }));

const passwordSchema = z
  .string()
  .trim()
  .min(6, { error: "Password should be at least 6 characters long." })
  .max(50, { error: "Password should not exceed 50 characters." });

export const loginSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
});

export const registerSchema = z
  .object({
    email: z
      .string()
      .trim()
      .min(1, { error: "Email address is required." })
      .pipe(z.email({ error: "Please enter a valid email address" })),
    password1: z
      .string()
      .min(8, { error: "Password must be at least 8 characters" })
      .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, {
        error:
          "Password must contain at least one uppercase letter, one lowercase letter, and one number",
      }),
    password2: z.string().min(1, { error: "Please confirm your password" }),
  })
  .refine((data) => data.password1 === data.password2, {
    error: "Passwords don't match",
    path: ["password2"],
  });

export const forgotPasswordSchema = z.object({
  email: emailSchema,
});

export const ssoLoginSchema = z.object({
  email: emailSchema,
});

/** URL search params for /auth/forgot-password-confirm – required for route to render */
export const forgotPasswordConfirmSearchSchema = z.object({
  uid: z.string().min(1),
  token: z.string().min(1),
});

export type LoginData = z.infer<typeof loginSchema>;
export type SsoLoginData = z.infer<typeof ssoLoginSchema>;
export type ForgotPasswordData = z.infer<typeof forgotPasswordSchema>;
export type ForgotPasswordConfirmSearch = z.infer<
  typeof forgotPasswordConfirmSearchSchema
>;
